
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#d80027","d":"M0 85.331h512v341.337H0z"}}),_c('g',{attrs:{"fill":"#ffda44"}},[_c('path',{attrs:{"d":"M178.923 189.567l14.656 45.107h47.429l-38.371 27.878 14.657 45.109-38.371-27.879-38.371 27.879 14.656-45.109-38.371-27.878h47.429zM271.3 339.593l-14.39-10.455-14.388 10.454 5.495-16.914-14.389-10.455h17.786l5.496-16.916 5.498 16.916h17.785l-14.389 10.454zM308.837 287.927h-17.785l-5.496 16.914-5.496-16.913-17.787-.001 14.391-10.455-5.498-16.915 14.39 10.453 14.389-10.453-5.496 16.915zM308.837 224.063l-14.388 10.455 5.495 16.914-14.388-10.453-14.39 10.455 5.498-16.917-14.391-10.452 17.788-.002 5.495-16.916 5.496 16.916zM271.3 172.397l-5.495 16.916 14.388 10.453-17.785.001-5.498 16.917-5.496-16.918-17.785.002 14.389-10.456-5.496-16.916 14.388 10.455z"}})])])
          )
        }
      }
    